import { render, staticRenderFns } from "./OrganizeTournament.vue?vue&type=template&id=5dc88a6d&scoped=true"
import script from "./OrganizeTournament.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizeTournament.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizeTournament.vue?vue&type=style&index=0&id=5dc88a6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc88a6d",
  null
  
)

export default component.exports